<template>
   <!-- footer -->
   <footer id="footer">
      <div class="footer">
         <div class="container">
            <div class="social-links">
               <ul v-html="socialLinks"></ul>
            </div>  <!-- .social-links -->

            <div class="global-links">
               <ul class="header-global-links" v-html="globalNav"></ul>
            </div> <!-- .global-links -->

            <ul class="legal-links" v-html="legalLinks"></ul>
         </div> <!-- .container -->
         <div class="appversion">
            {{ this.appVersion }}
         </div>
      </div> <!-- .footer -->

      <template v-html="footerChunk" />

   </footer>
</template>

<script>
   import { mapState } from 'vuex'
   export default {
      computed: {
         ...mapState({
            appTitle: state => state.global.appTitle,
            appSubtitle: state => state.global.appSubtitle,
            breadcrumbs: state => state.global.breadcrumbs,
            legalLinks: state => state.global.chunks['legal-links'],
            socialLinks: state => state.global.chunks['social-links'],
            footerChunk: state => state.global.chunks['footer'],
            globalNav: state => state.global.chunks['global-nav'],
            appVersion: state => state.global.appVersion
         })
      }
   }
</script>

<style>
</style>
